"use client";

import { usePathname } from "next/navigation";
import { cn } from "@/lib/utils";
import { useRouteTransition } from "@/providers/RouteTransitionProvider";

export default function RouteContentTransition({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const pathname = usePathname();
  const { isNavigating } = useRouteTransition();

  return (
    <div
      className={cn(
        "min-w-0 transition duration-200 ease-out",
        isNavigating ? "opacity-35" : "opacity-100",
        className
      )}
    >
      <div key={pathname} className="min-w-0 animate-route-enter">
        {children}
      </div>
    </div>
  );
}
